var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { attr } from '@ember-data/model';
import { tracked } from '@glimmer/tracking';
let TransferOrderLine = (_class = class TransferOrderLine extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "transferOrderId", _descriptor, this);
    _initializerDefineProperty(this, "transferOrderLineId", _descriptor2, this);
    _initializerDefineProperty(this, "itemVariation", _descriptor3, this);
    _initializerDefineProperty(this, "quantityReceived", _descriptor4, this);
    _initializerDefineProperty(this, "quantityCanceled", _descriptor5, this);
    _initializerDefineProperty(this, "quantityDamaged", _descriptor6, this);
    _initializerDefineProperty(this, "quantityPending", _descriptor7, this);
    _initializerDefineProperty(this, "totalQuantityOrdered", _descriptor8, this);
    // Tracked properties for non-persistent data
    _initializerDefineProperty(this, "quantityAtSource", _descriptor9, this);
    _initializerDefineProperty(this, "quantityAtDestination", _descriptor10, this);
  }
  get newQuantityAtSource() {
    if (this.quantityAtSource === undefined) {
      return 0;
    }
    return this.quantityAtSource - Number(this.totalQuantityOrdered);
  }
  get newQuantityAtDestination() {
    if (this.quantityAtDestination === undefined) {
      return 0;
    }
    return this.quantityAtDestination + Number(this.totalQuantityOrdered);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "transferOrderId", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "transferOrderLineId", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "itemVariation", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "quantityReceived", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "quantityCanceled", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "quantityDamaged", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "quantityPending", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "totalQuantityOrdered", [attr], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "quantityAtSource", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "quantityAtDestination", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TransferOrderLine as default };